import React from 'react';

import Tabs from 'features/records/containers/Tabs';

const Details = () => <Tabs />;

export default Details;
